import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  UpdateOrderCancelationReasonActions as Actions,
  UpdateOrderCancelationReasonRequestAction as RequestAction,
} from 'store/ducks/orders';

export function* updateOrderCancelationReasonRequest(action: any) {
  const { id, putData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.put, `orders/${id}/cancelation-reason`, putData, {
      headers: { 'X-Client-Origin': 'WEB' },
    });
    onSuccess && onSuccess();
    notify('success', 'Ordem de coleta cancelada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
